import React, { useContext, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { DataContext } from '../Context/dataContext'

import FormInput from './common/FormInput';
// import FormSuccess from './common/FormSuccess';
import FormError from './FormError'
import Label from './common/Label'
import Hyperlink from './common/Hyperlink'
import { FetchContext } from '../Context/fetchContext';
import FormSuccess from './FormSuccess';
import LoginBar from './LoginBar';

const LoginForm = ({ educator, person, barText, loginBarClasses }) => {
    const fetchContext = useContext(FetchContext);
    const dataContext = useContext(DataContext);
    const LoginSchema = Yup.object().shape({
        admissionNumber: Yup.string().required(educator ? 'Kindly enter your username or email to proceed' : 'Kindly enter your admission number or email to proceed'),
        password: Yup.string().required('Kindly input password')
    });

    const [loginSuccess, setLoginSuccess] = useState(null);
    const [loginError, setLoginError] = useState(null);
    const [loginLoading, setLoginLoading] = useState(null);
    const [usernameIsEmpty, setUsernameIsEmpty] = useState(false);

    const host = fetchContext.host; 
    // const currPortal = fetchContext.currPortal
    const currPortal = window.location.pathname.split('/')[2];
    const usertype = currPortal === '' ? 'educator' : `${currPortal}`
    console.log(usertype);

    const submitCredentials = async credentials => {
        let fullCredentials;
        if (usertype === 'educator' || usertype === 'parents') {
            fullCredentials = {
                username: credentials.admissionNumber,
                password: credentials.password,
                SchoolUrl: host,
            }
        } else {
            fullCredentials = {
                admissionnumber: credentials.admissionNumber,
                password: credentials.password,
                SchoolUrl: host,
            }
        }
        console.log(fullCredentials);
        try {
          setLoginLoading(true);
          const { data } = await fetchContext.postRoute(`auth/${usertype === '' ? 'educator' : usertype}/login`, fullCredentials);
          console.log(data);
          if(data.status) {
              setLoginLoading(false);
              setLoginSuccess(data.message);
              setLoginError('');
            //   localStorage.setItem('studentInfo', JSON.stringify(data.data))
              // redirect after successful login
              setTimeout(() => {
                  if(person === 'school staff') {
                    window.location.assign(`https://${host}/_prologin.php?userid=${credentials.admissionNumber}&token=${data.data[0].token}`)
                } else if(person === 'student') {
                    window.location.assign(`https://${host}/${person}s/locker`)
                } else {
                    window.location.assign(`https://basic.edves.net/new_auth.php?AdmissionNumber=${data.data[0].admissionnumber}&token=${data.data[0].token}&schoolID=${data.data[0].schoolUniqueId}&schoolUrl=${host}`)
                }
              }, 700)
          } else {
              setLoginError((data.message));
              setLoginLoading(false);
          }
       } catch (error) {
         setLoginLoading(false);
         setLoginError('Something Went Wrong');
         console.log(error);
        }
    };

    const handleFPwrd = () => {
        // setUsernameIsEmpty(true); 
        !usernameIsEmpty && dataContext.setFPswrdComponent(person)
    }

    // console.log(usernameIsEmpty)

    return (
        <>
            <Formik
                initialValues={{
                    admissionNumber: '',
                    password: ''
                }}
                onSubmit={values =>
                    submitCredentials(values)
                }
                validationSchema={LoginSchema}
                validate={(values) => {
                    if (!values.admissionNumber) {
                        console.log(values)
                        setUsernameIsEmpty(true)
                    } else {
                        setUsernameIsEmpty(false)
                        dataContext.setCredentials({
                            username: values.admissionNumber,
                            schoolUrl: host
                        })
                        console.log(values)
                    }
                    return {};
                }}
            >
                {({errors, touched}) => (
                    <Form className='mt-4'>
                        {loginSuccess && (
                            <FormSuccess text={loginSuccess} />
                        )}
                        {loginError && (
                            <FormError text={loginError} />
                        )}
                        <div className='space-y-4'>
                            <div className="">
                                <div className="mb-1 mx-auto w-full md:w-3/4 lg:w-full">
                                    <Label text={educator ? 'Username or Email Address' : "Admission Number"} />
                                </div>
                                <FormInput
                                    ariaLabel="AdmissionNumber"
                                    name="admissionNumber"
                                    type="text"
                                    placeholder="edves/20210402/Edves"
                                    usernameIsEmpty
                                />
                            </div>
                            <div>
                                <div className='flex justify-between mx-auto w-full md:w-3/4 lg:w-full'>
                                    <div className="mb-1">
                                        <Label text="Password" />
                                    </div>
                                    <div onClick={handleFPwrd} className="text-sm leading-5">
                                        <Hyperlink
                                            // to="forgot-password"
                                            text="Forgotten Password?"
                                        />
                                    </div>
                                </div>
                                <FormInput
                                    ariaLabel="Password"
                                    name="password"
                                    type="password"
                                    placeholder="Password"
                                />
                            </div>
                            <div>
                                <LoginBar 
                                    loading={loginLoading}
                                    type='submit'
                                    className= {loginBarClasses}
                                    text={barText} 
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default LoginForm;